/* eslint-disable react/self-closing-comp */
import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 45 45"
    >
      <path
        fill="#316BA3"
        d="M39.423 12.976c-1.58-1.747-4.22-2.621-8.05-2.621h-.446v-.074c0-3.124 0-6.99-6.99-6.99H21.11c-6.99 0-6.99 3.885-6.99 6.99v.093h-.446c-3.849 0-6.47.873-8.05 2.62-1.84 2.046-1.785 4.797-1.599 6.675l.019.13.168 1.767a.387.387 0 00.172.287c.372.245 1.323.867 1.853 1.162.26.168.54.316.818.465 3.18 1.747 6.674 2.919 10.225 3.495.168 1.747.93 3.792 5.001 3.792 4.071 0 4.87-2.026 5-3.83a31.286 31.286 0 0010.765-3.866c.111-.056.186-.112.279-.167.805-.456 1.643-1.026 2.39-1.572a.39.39 0 00.157-.271l.056-.5.092-.873c.019-.112.019-.205.038-.335.148-1.878.111-4.443-1.636-6.377zM24.55 25.711c0 1.97 0 2.268-2.287 2.268-2.286 0-2.286-.353-2.286-2.25v-2.342h4.573v2.324zm-7.77-15.356v-.074c0-3.16 0-4.332 4.33-4.332h2.827c4.331 0 4.331 1.19 4.331 4.332v.093H16.78v-.019z"
      ></path>
      <path
        fill="#316BA3"
        d="M39.893 25.113a.394.394 0 01.563.392l-.755 8.311c-.39 3.718-1.915 7.511-10.095 7.511H15.44c-8.18 0-9.704-3.792-10.094-7.492l-.719-7.906a.394.394 0 01.556-.395c1.76.813 6.843 3.104 9.587 3.756a.41.41 0 01.284.245c1.07 2.586 3.565 3.965 7.228 3.965 3.626 0 6.156-1.432 7.227-4.02a.41.41 0 01.284-.246c2.907-.69 8.275-3.234 10.1-4.121z"
      ></path>
    </svg>
  );
}

export default Icon;